export default __webpack_public_path__ + "a1bb7e4e53ca76fa0158f877a67e25ae.png";